import * as ISchema from "#webapp/src/__schema__";
import { useEffect, useRef } from "react";

export const useDetectLogout = (user: ISchema.IUser, onUserLoggedOut: () => void) => {
  const prevUserRef = useRef(user);

  useEffect(() => {
    if (!user && prevUserRef.current) {
      onUserLoggedOut();
    }

    prevUserRef.current = user;
  }, [user]);
};
